<template>
    <main>
        <div class="produ">
            <div class="title">
                <!-- <div class="active">印前设备</div> -->
                <div v-for="i in typeKey" @click="getEquipList(i.typeId)" :class="{ active: typeId == i.typeId }" v-if="i.label">{{ i.typeName }}</div>
            </div>
            <div class="context">
                <div class="item" v-for="i in equipList">
                    <div class="techImg">
                        <div v-if="i.devicePicture" @click="showDetail(i)">
                            <v-image :src="i.devicePicture" width="100%" height="100%" class="image"></v-image>
                        </div>
                        <!-- <img class="image" :src="i.devicePicture" alt="" v-if="i.devicePicture" @click="showDetail(i)"> -->
                        <video :src="i.deviceVideo" v-else>
                            your browser does not support the video tag
                        </video>
                        <div v-if="i.deviceVideo" @click="play(i)">
                            <div class="mask"></div>
                            <img class="playBtn" src="../assets/images/play.png" alt="">
                        </div>
                    </div>
                    <div class="techName">{{ i.deviceName }}</div>
                </div>
            </div>
        </div>
        <pager :xpages="pages" :xcurrent-page="pageNum" @pager="pageNum = $event"></pager>

        <transition name="fade">
            <div class="loginBox" v-if="equiDetail">
                <div class="box">
                    <div class="loginBg"></div>
                    <div class="login">
                        <div class="context">
                            <img :src="detail.devicePicture" alt="">
                            <div>
                                <div>{{ detail.deviceTypeName }}</div>
                                <div class="explain" v-html="detail.deviceExplain.replace(/\n/g, '<br/>')"></div>
                            </div>
                        </div>
                        <button class="close" @click.stop="equiDetail = false"></button>
                    </div>
                </div>

            </div>

        </transition>

        <video-alert :videoUrl="videoUrl" ref="video"></video-alert>
    </main>
</template>
<style lang="less" scoped>
@red: #e60012;

.produ {
    display: flex;
    max-width: 1664px;
    margin: auto;

    .title {
        width: calc(100% - 1600px);
        min-width: 152px;
        font-size: 18px;
        color: #353535;

        div {
            height: 50px;
            line-height: 50px;
            padding-right: 26px;
            text-align: right;
            position: relative;
            cursor: pointer;
            white-space: nowrap;
            border-top: 1px solid #D2D2D2;
            border-bottom: 1px solid transparent;

            &:last-child {
                border-bottom-color: #D2D2D2;
            }

            &.active {
                box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.12);
                border-top-color: transparent;
                border-bottom-color: transparent;
                background-color: #FFFFFF;

                &:after {
                    display: inline-block;
                    content: '';
                    width: 5px;
                    height: 40px;
                    background-color: @red;
                    position: absolute;
                    right: -5px;
                    top: 5px;
                }
            }

            &.active+div {
                border-top-color: transparent;
            }
        }
    }

    .context {
        width: 1500px;
        display: flex;
        flex-wrap: wrap;
        margin-left: 40px;

        .item {
            margin: 0 14px 11px;
            cursor: pointer;

            .techImg {
                width: 340px;
                height: 320px;
                border: 1px solid #D2D2D2;
                border-radius: 4px;
                overflow: hidden;
                position: relative;
                cursor: pointer;

                video,
                div,
                img {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    object-fit: cover;
                }

                .image {
                    transition: all .3s;

                    &:hover {
                        transform: scale(1.1);
                    }
                }

                .mask {
                    background-color: #ffffff;
                    opacity: 0.5;
                }

                .playBtn {
                    position: absolute;
                    top: 137px;
                    left: 147px;
                    width: 47px;
                    height: 47px;
                }
            }

            .techName {
                font-size: 14px;
                font-weight: 400;
                color: #353535;
                line-height: 50px;
            }
        }
    }

}

.loginBox {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 102;
    will-change: opacity;

    .box {
        position: relative;
        width: 720px;
        height: 344px;
    }

    .loginBg {
        position: absolute;
        top: 23px;
        width: 720px;
        height: 299px;
        z-index: 101;
        background-color: @red;
    }

    .login {
        position: absolute;
        left: 20px;
        width: 680px;
        height: 344px;
        background-color: #ffffff;
        padding: 26px 20px;
        border: none;
        overflow: hidden;
        z-index: 102;

        .context {
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;

            img {
                height: 220px;
                margin-right: 30px;
                object-fit: cover;
            }

            div {
                font-size: 16px;
                font-weight: bold;
                color: #363636;
                text-align: left;

                &.explain {
                    font-size: 14px;
                    font-weight: 400;
                    margin-top: 13px;
                    max-height: 200px;
                    overflow: scroll;
                }
            }
        }

        .close {
            border: none;
            width: 17px;
            height: 17px;
            position: absolute;
            right: 22px;
            top: 22px;
            background: transparent url(../assets/images/index/close.png) center/auto no-repeat;
        }

    }
}

@media screen and (max-width: 1360px) {
    .produ {
        flex-direction: column;
        min-width: auto;
    }

    .title {
        white-space: nowrap;
        overflow: auto;
        width: auto !important;
        padding: 0;

        div {
            display: inline-flex;
            min-width: 120px;
            justify-content: center;
            align-items: center;
            height: 40px !important;
            border: none !important;
            position: relative;
            padding: 0 !important;

            &.active {
                color: @red;
                font-weight: bold;
                box-shadow: none !important;

                &::after {
                    display: none !important;
                }
            }
        }
    }

    .context {
        width: 100% !important;
        margin-left: 0 !important;
        margin-top: 0 !important;
        justify-content: space-between;
        align-items: center;
        padding: 20px;

        .item {
            margin: 0 0 20px !important;
            width: calc(50% - 10px) !important;

            .techImg {
                width: 100% !important;
                height: 0 !important;
                padding-top: 100% !important;
                position: relative !important;

                .v-image {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;

                    /deep/ img {
                        object-fit: cover;
                    }
                }
            }
        }
    }
}
</style>
<script>
export default {
    data() {
        return {
            typeKey: [],
            equipList: [],
            typeId: '',
            equiDetail: false,
            detail: '',
            videoUrl: '',
        }
    },
    computed: {},
    methods: {
        getTypeKey() {
            var that = this;
            that.$root.loading = true;
            ajax.call(this, {
                url: "/bloc/deviceInfo/list/language1",
                data: {
                    organizationId: 1
                },
                s(res) {
                    that.$root.loading = false;
                    that.typeKey = res.data;
                    that.getEquipList(res.data[0].typeId)
                }
            });
        },
        getEquipList(index) {
            var that = this;
            that.typeId = index;
            that.getList();
        },
        getList() {
            var that = this;
            that.$root.loading = true;
            that.equipList = [];
            ajax.call(this, {
                url: "/bloc/deviceInfo/list/language",
                data: {
                    typeId: that.typeId,
                    organizationId: 1,
                    pageSize: 12
                },
                s(res) {
                    that.$root.loading = false;
                    that.equipList = res.data
                }
            });
        },
        showDetail(item) {
            this.equiDetail = true;
            this.detail = item;
        },
        play(item) {
            this.videoUrl = item.deviceVideo;
            this.$refs.video.played();
        }
    },
    mounted() {
        this.getTypeKey();
    },
    watch: {
        "$root.language"() {
            this.getTypeKey();
        },

    }
}
</script>